import { render, staticRenderFns } from "./departmentTable.vue?vue&type=template&id=76069443&scoped=true&"
import script from "./departmentTable.vue?vue&type=script&lang=js&"
export * from "./departmentTable.vue?vue&type=script&lang=js&"
import style0 from "./departmentTable.vue?vue&type=style&index=0&id=76069443&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76069443",
  null
  
)

export default component.exports